import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import type { DomainGuid } from '../..';
import { findFeature } from './findFeature';
import { Features } from '../../createGridElementCalculationSetExecutionDetails';

export const findGridElementLabel = (
  features: Features,
  objectId: DomainGuid
): string => {
  const feature = findFeature(features, objectId);
  return feature ? (feature.gc.title ? feature.gc.title : objectId) : objectId;
};

export const findGridElementTitle = (
  features: Features,
  objectId: DomainGuid
): string => {
  const feature = findFeature(features, objectId);
  return feature
    ? feature.gc.webMapTitle
      ? feature.gc.webMapTitle
      : feature.gc.title
      ? feature.gc.title
      : objectId
    : objectId;
};
